import * as brandColors from '../../../../../utils/brand-colors';

export default (theme) => ({
  eventTemplateSearchListContainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    overflow: 'auto',
  },
  contentContainer: {
    flex: 1,
    paddingTop: 0,
    paddingBottom: 0,
    overflow: 'auto',
  },
  center: {
    textAlign: 'center',
    margin: '1em',
    width: '100%',
  },
  centerProgress: {
    textAlign: 'center',
    margin: '1em',
  },
  eventTemplateListItem: {
    padding: '16px 0 12px',
    margin: 0,
  },
  listItemRoot: { margin: 0 },
  listItemPrimary: {
    lineHeight: 1,
    marginBottom: '4px',
  },
  paginationButton: { margin: theme.spacing(1) },
  paginationContainer: {
    textAlign: 'center',
    marginTop: theme.spacing(2),
  },
  alignCenter: { textAlign: 'center' },
  dataDivider: { marginBottom: '.5em' },
  skipListItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '16px 0',
  },
  skipIcon: {
    color: brandColors.grey.main,
    marginRight: '1rem',
  },
});
